import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAccount } from "@/lib/AccountContext";
import { useLang } from "@/lib/i18n";

export default function ProtectedAccountRoute({ children }) {
  const { user, loading } = useAccount();
  const { t } = useLang();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-[60vh] grid place-items-center text-sm text-muted-foreground" data-testid="account-route-loading">
        {t("account.loading")}
      </div>
    );
  }
  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ returnTo: `${location.pathname}${location.search || ""}` }}
      />
    );
  }
  return children;
}
